import Loading from '$components/Loading'
import { useTenantStore } from '$hooks/services/useTenants'
import { ROUTE_NAMES } from '$router/config'
import Navigate from '$router/Navigate'

const IndexPage = () => {
  const currentTenantId = useTenantStore(state => state.currentTenant?.id)
  const tenants = useTenantStore(state => state.tenants)

  const tenantId = currentTenantId || tenants[0]?.id

  if (!tenantId) {
    return <Loading />
  }

  return (
    <Navigate
      to={ROUTE_NAMES.TENANT_STATISTICS}
      options={{ params: { tenantId }, replace: true }}
    />
  )
}

export default IndexPage
